/**
 * The default resolver.
 */
var InstantiationResolver = /** @class */ (function () {
    function InstantiationResolver() {
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    InstantiationResolver.prototype.add = function (_type) {
        // ignored - the instantiation resolver does not need to register anything.
    };
    InstantiationResolver.prototype.resolve = function (type) {
        return new type();
    };
    return InstantiationResolver;
}());
export { InstantiationResolver };
//# sourceMappingURL=instantiationResolver.js.map